/* global process */
let finDomain = window._env_.VUE_APP_FIN_CENTER_HOST
export const queryPayCondition = params => {
  return axios.post(`${finDomain}/pay_condition/lists`, params)
}
export const getPayCondition = params => {
  return axios.get(`${finDomain}/pay_condition/${params.id}`)
}
export const createPayCondition = params => {
  return axios.post(`${finDomain}/pay_condition/create`, params)
}
export const updatePayCondition = params => {
  return axios.post(`${finDomain}/pay_condition/${params.id}/edit`, params)
}
export const enablePayCondition = params => {
  return axios.post(`${finDomain}/pay_condition/${params.id}/enable`, params)
}
export const disablePayCondition = params => {
  return axios.post(`${finDomain}/pay_condition/${params.id}/disable`, params)
}
export const uploadPayConditionFile = params => {
  return axios.post(`${finDomain}/pay_condition/upload`, params)
}



// WEBPACK FOOTER //
// ./src/views/pay-conditions/pay-conditions.api.js